/* eslint-disable react/jsx-no-useless-fragment */
import { CircularProgress, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
// import { Debounce } from '../../helper/commonHelper';
import { useDiscoverSearchAuth } from '../../context/DiscoverSearchContext';
import { API_LIMIT_DATA, searchFilter } from '../../utils/constants';
import { ADD_DISCOVER_DATA } from '../../redux/constants';
import Iconify from '../../fl-components/Iconify';
import { searchClasses } from '../../service/discoverSearch.service';

export default function DiscoverSearchBar({ sx }) {
  const { isSearching, setIsSearching, setSearchValue, searchValue } = useDiscoverSearchAuth();
  const dispatch = useDispatch();

  const makeApiCall = async (search) => {
    const res = await searchClasses(search, API_LIMIT_DATA, 0, searchFilter);
    if (res) {
      dispatch({
        type: ADD_DISCOVER_DATA,
        payload: {
          data: res.hits,
          offset: 1
        }
      });
    }
    setIsSearching(false);
  };

  // const handleSearch = Debounce(
  //   (e) => {
  //     setIsSearching(true);
  //     setSearchValue(e.target.value);
  //     makeApiCall(e.target.value);
  //   },
  //   2000,
  //   false
  // );

  return (
    <OutlinedInput
      onChange={(e) => {
        // handleSearch(e);
        if (e.target.value.trim()) {
          setSearchValue(e.target.value);
          makeApiCall(e.target.value);
          setIsSearching(true);
        }
      }}
      id="discover-search-input"
      placeholder="Search by Class Name, Subject, and Category"
      endAdornment={
        <>
          {isSearching ? (
            <InputAdornment position="end">
              <CircularProgress color="inherit" size={15} />
            </InputAdornment>
          ) : (
            <>
              {!isSearching && searchValue ? (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      document.getElementById('discover-search-input').value = '';
                      setSearchValue('');
                      makeApiCall('');
                    }}
                  >
                    <Iconify icon="eva:close-outline" />
                  </IconButton>
                </InputAdornment>
              ) : null}
            </>
          )}
        </>
      }
      sx={{
        width: { xs: '90%', md: '45%' },
        zIndex: 1,
        backgroundColor: 'white',
        ...sx
      }}
    />
  );
}

DiscoverSearchBar.propTypes = {
  sx: PropTypes.object
};
